import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar/NavBar';
import Footer from './components/Footer/Footer';
import Editor from './pages/Editor/Editor';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import './App.css';

const App = () => (
  <BrowserRouter>
    <div className="app">
      <div className="app-rule" />
      <NavBar />
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Editor />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  </BrowserRouter>
);

export default App;
